import React from 'react'
import injectStyles from 'react-jss'

import AuthWrapper from '../../../Containers/Auth/AuthWrapper'
import { styles } from './styles'
import LogInIllustration from '../../../Assets/Images/icons/LogInIllustration'
import { Box, Grid } from '@material-ui/core'
const VerifyEmail = ({ classes }) => {
  const urlParams = new URLSearchParams(window.location.search)
  const status = urlParams.get('status')
  const success = ['success', 'already-rated', 'already-verified'].includes(
    status,
  )
  const title = `Email Verification  ${success ? 'Successful' : 'Error'}`
  const description = success
    ? 'Your email was successfully verified. You can now return to the app to login or continue.'
    : ' This link is no longer valid.'

  return (
    <AuthWrapper>
      <Grid container spacing={4}>
        <Grid
          container
          item
          xs={12}
          md={6}
          alignItems="center"
          justifyContent="center"
          className="h-100"
        >
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            className={'content has-large-padding h-100'}
          >
            <Box className="content-inner">
              <h1 className="text-center">{title}</h1>
              <div className="text-center">{description}</div>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <LogInIllustration className={'illustration'} />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default injectStyles(styles)(VerifyEmail)
